<template>
  <div class="introductionn-main">
    <div class="line"></div>
    <div v-if="isShow" class="introduction">
      <div class="img-bg">
        <img class="playCover" :src="videoCover" alt />
        <img
          class="playBtn"
          src="../../assets/images/bf.png"
          alt
          @click="showVideo"
        />
      </div>
      <p class="contxt">
       博为峰股份，公司全称上海博为峰软件技术股份有限公司，成立于2004年，总部位于中国上海，是一家以前沿技术为核心，涵盖职业培训，企业服务，门户网站的综合型科技公司，于2016年挂牌新三板，股票代码836392。
      </p>
      <p class="contxt">
        旗下设有「学掌门教育」，「博为峰企业服务」和「51Testing软件测试网」三大品牌。截止至2024年底，博为峰股份旗下业务已覆盖全国18个城市。学掌门教育累计服务学员数近10万，累计开班超3000期。博为峰企业服务累计服务企业超800家。51Testing软件测试网注册用户超百万。
      </p>
      <p class="title">企业文化</p>
      <div />
      <p class="contxt">
        使命：以科技普及科技，链接企业与人才，成就美好未来
      </p>
      <p class="contxt">
        愿景：源源不断的为行业培育和输送紧缺人才，成为企业与个人可信赖的合作伙伴
      </p>
      <p class="contxt">
        价值观：客户第一，以人为本，诚实守信，艰苦奋斗
      </p>
    </div>
    <IntroVideo
      class="backWrap"
      v-if="isVideo"
      @isVideo="isShowVideo"
      :videoUrl="url"
      :videoCover="videoCover"
    />
  </div>
</template>

<script>
import IntroVideo from "../video/IntroVideo";
export default {
  props: ["navID"],
  components: {
    IntroVideo
  },
  data() {
    return {
      isShow: true,
      isVideo: false,
      url: "",
      videoCover: ""
    };
  },
  created() {
    this.getUrl();
  },
  watch: {
    navID: {
      handler: function() {
        if (this.navID === 1) {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      },
      immediate: true
    }
  },
  methods: {
    showVideo() {
      this.isVideo = true;
    },
    isShowVideo: function(val) {
      this.isVideo = val;
    },
    getUrl() {
      this.axios.get("/api/consume/OtherInfo").then(res => {
        this.url = res.data.videoUrl;
        this.videoCover = res.data.videoCover;
      });
    }
  }
};
</script>

<style scoped>
.introduction {
  text-align: center;
  padding: 0 35.5px;
  padding-bottom: 60px;
  overflow: hidden;
}
.introductionn-main .line {
  background: #f4f4f4;
  height: 14.5px;
}
.introduction .img-bg {
  margin-top: 27px;
  margin-bottom: 3%;
  /* width: 602px; */
  margin-left: 20px;
  margin-right: 20px;
  height: 349px;
  position: relative;
}
.introduction .img-bg .playCover {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.introduction .img-bg .playBtn {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.introduction .contxt {
  color: #858585;
  font-size: 24px;
  text-align: left;
  line-height: 33px;
  text-indent: 2em;
}
.introduction .title {
  width: 100%;
  color: #333;
  line-height: 29px;
  font-weight: bold;
  text-align: left;
  text-indent: 0;
  padding-top: 2%;
  padding-bottom: 2%;
  font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/about/Introduction.vue